import api from './api';

export const userPromptsApi = {
  getUserPrompts: (documentType: 'bid' | 'proposal') =>
    api.get<any[]>(`/api/user/prompts?document_type=${documentType}`),

  switchMode: (key: string, mode: string, versionId?: number) =>
    api.put(`/api/user/prompts/${key}/mode`, { mode, version_id: versionId }),

  saveVersion: (key: string, data: { content_system: string; content_user: string | null }) =>
    api.post(`/api/user/prompts/${key}/versions`, data),

  getVersions: (key: string) =>
    api.get<any[]>(`/api/user/prompts/${key}/versions`),

  deleteVersion: (key: string, id: number) =>
    api.delete(`/api/user/prompts/${key}/versions/${id}`),
};
